import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CreateProcessListDialogComponent } from '../create-process-list-dialog/create-process-list-dialog.component';
import * as moment from 'moment';
import { Observable, Subject, from } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { catchError, concatMap, map } from 'rxjs/operators';
import { MatTabGroup } from '@angular/material/tabs';
import { OneSignalService } from 'src/services/onesignal.service';
import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { GoogleAuthService } from 'src/services/google-calendar.service';


@Component({
  selector: 'app-process-list-interview-session-dialog',
  templateUrl: './process-list-interview-session-dialog.component.html',
  styleUrls: ['./process-list-interview-session-dialog.component.scss']
})
export class ProcessListInterviewSessionDialogComponent implements OnInit {

  interviews: Array<any>;
  candidates: Array<any>
  processListId: number;
  selectedInterview: any = null;
  selectedIndex: number = 0;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  @ViewChild('candidatesList', { static: false }) candidatesList: MatSelectionList;
  @ViewChild('interviewTabs', { static: false }) interviewTabs: MatTabGroup;
  sessions: Array<any> = [];
  submiting: boolean = false;
  excludeDays: Array<string> = [];
  formExcludeDays: FormGroup;
  isSmallScreen$: Observable<boolean>;
  disableFinish: boolean = true;
  processList: any;
  areAllCandidatesSelected = false;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<CreateProcessListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    @Inject('MIDIA_ENDPOINT') public mediaEndpoint: string,
    fb: FormBuilder,
    private breakpoint: BreakpointObserver,
    private oneSignalService: OneSignalService,
    private googleAuthService: GoogleAuthService,
  ) {
    this.processListId = data.processListId;
    this.processList = data.processList;

    if (data.interview)
      this.selectedInterview = data.interview;

    this.formExcludeDays = fb.group({
      days: [null, Validators.required]
    });
  }

  ngOnInit(): void {

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;
        if (scope.indexOf('process_list:sessions') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)

    this.getInterviews();
    this.getProcessListLead();

    // this.formExcludeDays
    //   .valueChanges
    //   .subscribe(
    //     result => {

    //       if (!this.formExcludeDays.invalid) {
    //         this.excludeDays.push(result.days)
    //         this.formExcludeDays.reset();
    //       }
    //     }
    //   )

  }

  getInterviews() {

    this.http.list('process_list:interview', { processList: this.processListId })
      .subscribe(
        (result: any) => {
          this.interviews = result.data;
          if (this.selectedInterview)
            this.selectInterview(this.selectedInterview);
        }
      )

  }

  private getInterviewSessions() {

    this.http.list('process_list:sessions', { interview: this.selectedInterview.id })
      .subscribe(
        (result: any) => {
          if (!Array.isArray(result)) {
            result = [];  
          }

          let newTimeIndex = 0;

          for (const session of result) {

            let iSession = this.sessions.find(_session =>
              moment(_session.timeAt, 'HH:mm').isSame(moment(session.time_start, 'HH:mm'))
              && moment(_session.date, 'YYYY-MM-DD').isSame(moment(session.date, 'YYYY-MM-DD')));

            if (!iSession) {

              const { next_days, date_start, time_start, time_end, candidates_session_duration } = this.selectedInterview;

              if (next_days == 0)
                break;

              iSession = {
                timeAt: moment(session.time_start, 'HH:mm').format('HH:mm'),
                date: session.date,
                timeEnd: moment(session.time_end, 'HH:mm').format('HH:mm'),
              };

              this.sessions.push(iSession)
              newTimeIndex++;

            }

            if (iSession) {

              iSession.id = session.id;
              iSession.accept = session.accept;
              iSession.blocked = session.blocked == 1;

              if (session.lead_id) {
                iSession.candidate = {
                  id: session.lead_id,
                  firstname: session.firstname,
                  lastname: session.lastname,
                  accept: session.accept,
                  avatar_profile: session.avatar_profile,
                  link_meet: session.link_meet,
                }
              }

            }

          }
        }
      )

  }

  private getProcessListLead() {

    this.http.get('process_list:lead', { processList: this.processListId })
      .subscribe(
        (result: any) => this.candidates = result.data,
        err => this.errorReport.showMessage(err)
      )

  }

  selectInterview(interview) {

    if (this.sessions.length > 0) {
      this.stepper.next();
      return;
    }

    this.selectedInterview = interview;
    const { time_start, time_end, candidates_session_duration, date_start } = this.selectedInterview;

    const timeEndMoment = moment(time_end, 'HH:mm');
    const timeStartMoment = moment(time_start, 'HH:mm');
    const diffMinutes = timeEndMoment.diff(timeStartMoment, 'minutes');
    const sessions = diffMinutes / candidates_session_duration;

    for (let i = 0; i < sessions; i++) {
      const timeAt = moment(time_start, 'HH:mm').add(i * candidates_session_duration, 'minutes');
      this.sessions.push({
        timeAt: timeAt.format('HH:mm'),
        date: date_start,
        timeEnd: timeAt.add(candidates_session_duration - 1, 'minutes').format('HH:mm')
      });
    }

    setTimeout(() => {
      this.stepper.next();
      this.getInterviewSessions();
    }, 500)
  }

  toggleSelectCandidates() {
    if (this.areAllCandidatesSelected) {
      this.deselectAll();
    } else {
      this.selectAll();
    }
    this.areAllCandidatesSelected = !this.areAllCandidatesSelected; // Alterna o estado
  }

  selectAll() {
    this.candidatesList.options.forEach(option => {
      const candidate = option.value;
      if (!this.sessions.find(session => session.candidate && (session.candidate.id == candidate.id)))
        option.selected = true
    })
    //this.candidatesList.selectAll();
  }

  deselectAll() {
    this.candidatesList.options.forEach(option => {
      const candidate = option.value;
      if (!this.sessions.find(session => session.candidate && (session.candidate.id == candidate.id)))
        option.selected = false
    })
    //this.candidatesList.selectAll();
  }

  hasSelection() {
    return this.candidatesList && this.candidatesList.selectedOptions.selected.length > 0
    //&& (this.candidatesList.selectedOptions.selected.length !== this.sessions.filter(session => session.candidate).length);
  }

  blockSession(blocked: boolean, i: number) {

    const session = this.sessions[i];
    session.blocked = blocked;

  }

  addCandidateInSession(startSessionIndex = 0) {
    this.selectedIndex = 1;

    const candidates = this.candidatesList.selectedOptions.selected.map(selected => selected.value);

    let newTimeIndex = 0;
    let nextDay = 1;

    for (let i = 0; i < candidates.length; i++) {
        const candidate = candidates[i];
        if (!candidate) break;

        // Filtrar sessões não bloqueadas e sem candidato
        let sessions = this.sessions.slice(startSessionIndex);

        // Verificar se há sessões bloqueadas e ajustar o índice de tempo conforme necessário
        for (const session of sessions) {
            if (session.blocked) {
                // Adiciona 30 minutos ao índice de tempo para evitar o horário bloqueado
                newTimeIndex += 0.5; // 30 minutos
            }
        }

        // Refiltrar sessões para obter apenas as disponíveis
        sessions = sessions.filter(session => !session.candidate && !session.blocked);
        if (sessions.length > 0) {
            // Atribuir candidato à primeira sessão disponível e removê-la da lista
            const session = sessions.shift();
            session.candidate = candidate;
        } else {
            const { next_days, date_start, time_start, time_end, candidates_session_duration } = this.selectedInterview;

            if (next_days === 0) break;

            // Gerar nova data de sessão, evitando dias excluídos
            let nextDate = moment(date_start).add(nextDay, 'days');
            while (this.excludeDays.findIndex(day => moment(day).isSame(nextDate)) > -1) {
                nextDay++;
                nextDate = moment(date_start).add(nextDay, 'days');
            }

            // Gerar horário da sessão para o próximo candidato
            let timeAt = moment(time_start, 'HH:mm').add(newTimeIndex * candidates_session_duration, 'minutes');

            // Checar se existe uma sessão bloqueada para ajustar o horário
            if (this.sessions.some(session => session.blocked && moment(session.timeAt, 'HH:mm').isSame(timeAt))) {
                timeAt = timeAt.add(30, 'minutes'); // Adiciona 30 minutos
            }

            this.sessions.push({
                timeAt: timeAt.format('HH:mm'),
                date: nextDate.format('YYYY-MM-DD'),
                timeEnd: timeAt.add(candidates_session_duration - 1, 'minutes').format('HH:mm'),
                candidate
            });

            newTimeIndex++;

            // Verificar se o horário de término foi alcançado e mover para o próximo dia se necessário
            if (timeAt.isSameOrAfter(moment(time_end, 'HH:mm'))) {
                newTimeIndex = 0;
                nextDay++;
            }
        }
    }

    this.candidatesList.deselectAll();
    this.disableFinish = false;
  }

  hasCandidateSelected(candidate) {

    return this.sessions.find(session => session.candidate && (session.candidate.id == candidate.id));

  }

  isSameDate(i) {

    const previousSession = this.sessions[i - 1];
    if (!previousSession) return false;

    const session = this.sessions[i];

    return moment(session.date).isSame(moment(previousSession.date));

  }

  removeCandidate(i) {

    if (!confirm('Deseja realmente remover esse candidato da entrevista?'))
      return;

    const session = this.sessions[i];

    if (session.accept == 1) {
      alert('Esse candidato não pode ser removido, ele já aceitou o convite para entrevista');
      return;
    }

    if (!session.id)
      delete this.sessions[i].candidate;
    else {

      this.http.delete('process_list:sessions', { id: session.id })
        .subscribe(
          (result: any) => {

            if (result.type === 'OK') {
              this.snackbar.open('Candidato removido com sucesso', 'OK', { duration: 3000 });
              delete this.sessions[i].candidate;
            }

          },
          err => this.errorReport.showMessage(err)
        )

    }

  }

  finish() {
    
    if (this.selectedInterview.type === 'true') {
      
      if (!confirm('Para prosseguir com o agendamento das entrevistas remotas, será necessário fazer login em uma conta Google. Os eventos e links de acesso serão enviados automaticamente aos candidatos. Deseja continuar?'))
        return;

    }

    const data = {
      interview: this.selectedInterview.id,
      sessions: JSON.stringify(
        this.sessions.filter(session => session.candidate || session.blocked)
      )
    }
    this.http.save('process_list:sessions', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Sessões das entrevistas cadastradas com sucesso!', 'OK', { duration: 3000 });
            this.dialogRef.close(true);
            this.disableFinish = true;
          }
        },
        err => this.errorReport.showMessage(err)
      )

    this.http.save('process_list_action', {
      processList: this.processListId,
      action: 'interview',
      leads: this.sessions.filter(session => session.candidate).map(session => session.candidate.id)
    })
      .subscribe((result: any)=>{
        if (result.type === 'OK') {
            
          this.http.save('onsignal:getUser', {
            leads: { lead_ids: this.sessions.filter(session => session.candidate).map(session => session.candidate.id) }
          }).pipe(
            concatMap((result: any) => {
              //console.log('[Step 1] Resultado do "onsignal:getUser":', result);
              if (result.type !== 'OK') {
                throw new Error('Erro ao obter dados para o envio da notificação');
              }
          
              const signatureIds = result.data.map((item: any) => item.signature_id);
              //console.log('[Step 2] Signature IDs extraídos:', signatureIds);
              const notification_for_all = null;
              const title = 'Nova Entrevista';
              const fullname = null;
              const message = this.oneSignalService.listMessage(5, fullname, this.processList.name);
              //console.log('[Step 3] Mensagem gerada:', message);
          
              if (this.selectedInterview.type === 'true') {
                //console.log('[Step 4] Tipo de entrevista é "true", iniciando integração com Google');
                const user = JSON.parse(localStorage.getItem('token'));
                const leads = this.sessions.filter(session => session.candidate).map(session => ({
                  lead_id: session.candidate.id,
                  date: session.date,
                  timeAt: session.timeAt,
                  timeEnd: session.timeEnd,
                }));
                //console.log('[Step 5] Leads processados:', leads);
          
                return from(this.googleAuthService.signIn()).pipe(
                  concatMap((token) => {
                    //console.log('[Step 6] Token Google recebido:', token);
                    return this.http.save('google:storeToken', { code: token });
                  }),
                  concatMap((storeTokenResult: any) => {
                    //console.log('[Step 7] Resultado do "google:storeToken":', storeTokenResult);
                    if (storeTokenResult.type !== 'OK') {
                      throw new Error('Erro ao salvar o token do Google');
                    }
                    return this.http.save('google:createEvent', {
                      leads,
                      companie_mail: user.email,
                      access: storeTokenResult.access,
                      refresh: storeTokenResult.refresh,
                      id: this.selectedInterview.id
                    });
                  }),
                  concatMap((eventResult: any) => {
                    //console.log('[Step 8] Evento criado com sucesso:', eventResult);
          
                    const personalizedNotifications = eventResult.results.map((result: any) => ({
                      lead_id: result.lead_id,
                      meetLink: result.meetLink,
                      candidate: result.candidate,
                    }));
          
                    //console.log('[Step 9] Notificações personalizadas:', personalizedNotifications);
          
                    const sessionLeadIds = this.sessions
                      .filter(session => session.candidate)
                      .map(session => session.candidate.id);
          
                    const filteredNotifications = personalizedNotifications.filter(notification =>
                      sessionLeadIds.includes(notification.lead_id)
                    );
          
                    //console.log('[Step 10] Notificações filtradas:', filteredNotifications);
          
                    const leadIds = filteredNotifications.map(notification => notification.lead_id);
          
                    return this.http.save('onsignal:getUserNew', { leads: { lead_ids: leadIds } }).pipe(
                      map((result: any) => {
                        if (result.type === 'OK') {
                          const signatureMap = result.data.reduce((acc: any, item: any) => {
                            acc[item.lead_id] = item.signature_id;
                            return acc;
                          }, {});
          
                          //console.log('[Step 11] Signature IDs mapeados:', signatureMap);
                          
                          return filteredNotifications.map(notification => ({
                            ...notification,
                            signature_id: signatureMap[notification.lead_id],
                          })).filter(notification => notification.signature_id);
                        } else {
                          throw new Error('Erro ao obter signatures para os lead_ids');
                        }
                      })
                    );
                  }),
                  concatMap((notificationsWithSignatures: any[]) => {
                    const title = 'Nova Entrevista';
                    const notification_for_all = null;
          
                    return from(notificationsWithSignatures).pipe(
                      concatMap(notification => {
                        
                        const dia = this.selectedInterview.date_start; // "2025-01-22"
                        const hora = this.selectedInterview.time_start; // "12:00:00"

                        // Formata a data para o padrão BR
                        const formattedDate = dia.split('-').reverse().join('/'); // "22/01/2025"

                        // Concatena a data com a hora formatada
                        const finalFormattedDate = `${formattedDate} às ${hora.substring(0, 5)}`;
                        
                        const message = this.oneSignalService.listMessage(9, fullname, this.processList.name, null, finalFormattedDate, notification.meetLink);
                      
                        //console.log(`[Step 13] Enviando notificação para o signature_id ${notification.signature_id}:`, message);
          
                        return this.oneSignalService.sendNotification(
                          [notification.signature_id],
                          title,
                          message,
                          notification_for_all
                        );
                      })
                    );
                  })
                );
              } else {
                //console.log('[Step 4] Tipo de entrevista não é "true", pulando integração com Google');
                return this.oneSignalService.sendNotification(signatureIds, title, message, notification_for_all);
              }
            }),
            catchError((error) => {
              console.error('[Error] Ocorreu um erro:', error);
              this.errorReport.showMessage(error);
              throw error;
            })
          ).subscribe(
            (notificationResult: any) => {
              //console.log('[Step 9] Notificação enviada com sucesso:', notificationResult);
              if (notificationResult.type === 'OK') {
                this.oneSignalService.listNotification();
                this.snackbar.open('Entrevistas agendadas com sucesso!', 'OK', { duration: 5000 });
              } else {
                console.error('Erro ao enviar notificação para o candidato sobre o teste');
              }
            },
            (err) => {
              console.error('[Error] Erro no fluxo de execução:', err);
            }
          );          

        }
      },
      err => this.errorReport.showMessage(err)
    );

  }

  /*disableFinish() {
    return this.sessions.filter(session => session.candidate || session.blocked !== undefined).length === 0;
  }*/

  removeExcludeDay(i: number) {
    this.excludeDays.splice(i, 1);
  }

  onSubmit() {
    // Verifica se o formulário está válido
    if (!this.formExcludeDays.invalid) {
        // Adiciona o dia de exceção à lista
        this.excludeDays.push(this.formExcludeDays.value.days);
        
        // Reseta o formulário
        this.formExcludeDays.reset();
    }
  }

  onSessionDropped(event: CdkDragDrop<any>, sessionIndex: number): void {
    // Obter o candidato arrastado
    const candidate = event.item.data;
  
    // Marcar o candidato como selecionado no checkbox
    const candidateIndex = this.candidates.findIndex(c => c === candidate);
    if (candidateIndex >= 0) {
      this.candidatesList.selectedOptions.select(this.candidatesList.options.toArray()[candidateIndex]);
    }
  
    // Chamar a função addCandidateInSession para agendar o candidato
    this.addCandidateInSession(sessionIndex);
  }

  // Quando o candidato é movido de volta para a lista de candidatos
  onCandidateDropped(event: CdkDragDrop<any[]>) {
    if (event.previousContainer !== event.container) {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  async onSignIn(): Promise<void> {
    const accessToken = this.googleAuthService.signIn();
    //console.log('Access Token:', accessToken);
  }

  formatTime(time: string): string {
    return time.substring(0, 5); // Retorna apenas os primeiros 5 caracteres (HH:mm)
  }

  checkDateAndConfirm(event: MouseEvent, dateStart: string, timeStart: string): void {
    const currentDate = new Date(); // Data e hora atual
  
    // Quebra a string "2025-01-22" em ano, mês e dia
    const [year, month, day] = dateStart.split('-').map(Number);
  
    // Quebra a string "12:00" em hora e minuto
    const [hour, minute] = timeStart.split(':').map(Number);
  
    // Cria a data ajustada (mês é zero-indexado, hora e minuto são considerados)
    const startDate = new Date(year, month - 1, day, hour, minute);
    
    // console.log('currentDate', currentDate);
    // console.log('startDate', startDate);

    // Compara as datas e horas
    if (currentDate < startDate) {
      const proceed = confirm('A entrevista ainda não começou. Deseja continuar mesmo assim?');
      if (!proceed) {
        event.preventDefault(); // Impede o redirecionamento
      }
    }
  }

}
